/* fx-launch-b.js: the Find your part modal, part two.
   7. Model and year tab: cross filtered year and model lists.
   8. One shared height for the three tab panels, so the dialog stops moving
      when you switch tab.
   9. Fit chips hidden while the trailer context has no model.
   10. My trailer drawer: its two footer buttons do something useful while the
       VIN modal is open instead of nothing.
   11. Policy links: stop the app extension throwing the shopper back out of a
       policy page the moment they open one.
   Split out of fx-launch.js only because one theme file of that size starts
   truncating on a write. Nothing here is shared with that file. */
(function () {
  "use strict";

  var frame = 0;

  /* 7. Find your part, Model and year tab. The extension lists every year and
     every model name it has products for, with no relationship between the
     two, so 2019 still offered 2026-only models. The selector matrix that
     drives the chips everywhere else is the same data, so both lists are
     filtered from it: pick a year and only the models built that year remain,
     pick a model and only its years remain. */
  var pool = { years: [], models: [] };
  /* Values this file wrote into the model select itself. They must never be
     read back into the facet pool, or the matrix seeded entries would come
     back round as their own API name and lose their shopper facing label. */
  var ours = {};

  function optValues(sel) {
    var out = [];
    for (var i = 0; i < sel.options.length; i++) {
      var v = String(sel.options[i].value || "").trim();
      if (v) out.push(v);
    }
    return out;
  }

  function addAll(list, values) {
    for (var i = 0; i < values.length; i++) if (list.indexOf(values[i]) === -1) list.push(values[i]);
  }

  function modelYears(m) {
    var M = window.TrailerSelectorMatrix;
    var out = [];
    (m.ranges || []).forEach(function (rid) {
      M.yearsFor(rid).forEach(function (y) {
        if (out.indexOf(String(y)) === -1) out.push(String(y));
      });
    });
    return out;
  }

  /* `pairs` is [{v: value sent to the parts search, l: what the shopper
     reads}]. They differ for the matrix seeded entries: SHIFTR 1883 is sold
     under that name but the catalogue vocabulary for it is "SHIFTR". */
  function fillSelect(sel, pairs) {
    var anyOpt = sel.querySelector('option[value=""]');
    var anyLabel = anyOpt ? anyOpt.textContent : "Any";
    var keep = String(sel.value || "").trim();
    var kept = false;
    sel.innerHTML = "";
    var first = document.createElement("option");
    first.value = "";
    first.textContent = anyLabel;
    sel.appendChild(first);
    pairs.forEach(function (p) {
      var o = document.createElement("option");
      o.value = p.v;
      o.textContent = p.l;
      sel.appendChild(o);
      ours[String(p.v).toUpperCase()] = 1;
      if (keep && p.v === keep) kept = true;
    });
    if (kept) {
      sel.value = keep;
      return false;
    }
    sel.selectedIndex = 0;
    return !!keep;
  }

  function values(pairs) {
    return pairs.map(function (p) { return p.v; });
  }

  function brandMarks(panel) {
    var tpl = document.getElementById("fx-marks");
    if (!tpl || !tpl.content) return;
    var btns = panel.querySelectorAll(".vin-filter-brand-btn");
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.querySelector(".fx-bmark")) continue;
      var shiftr = /shiftr/i.test(b.textContent) || b.getAttribute("data-brand") === "SHIFTR";
      var mark = tpl.content.querySelector(shiftr ? ".fx-mk--shi" : ".fx-mk--fut");
      if (!mark) continue;
      var svg = mark.cloneNode(true);
      svg.classList.add("fx-bmark");
      svg.removeAttribute("style");
      b.insertBefore(svg, b.firstChild);
    }
  }

  function filtersTab() {
    var panel = document.getElementById("vinPanelFilters");
    var ySel = document.getElementById("vinFilterModelYear");
    var mSel = document.getElementById("vinFilterModelName");
    var M = window.TrailerSelectorMatrix;
    if (!panel || !ySel || !mSel || !M) return;
    brandMarks(panel);

    addAll(pool.years, optValues(ySel));
    addAll(pool.models, optValues(mSel).filter(function (v) { return !ours[v.toUpperCase()]; }));
    if (!pool.years.length || !pool.models.length) return;

    var activeBtn = panel.querySelector(".vin-filter-brand-btn.is-active");
    var shiftrBrand = !!activeBtn && /shiftr/i.test(activeBtn.textContent + (activeBtn.getAttribute("data-brand") || ""));
    var year = String(ySel.value || "").trim();
    var model = String(mSel.value || "").trim();

    var brandOk = function (name) {
      var m = M.modelByName(name);
      if (m) return (m.brand === "SHIFTR") === shiftrBrand;
      return /shiftr/i.test(name) === shiftrBrand;
    };
    var coversYear = function (name, y) {
      var m = M.modelByName(name);
      if (!m) return true;
      return modelYears(m).indexOf(String(y)) > -1;
    };

    /* Model names come off the catalogue facets AND off the matrix, not off
       the facets alone. The facet list is built from products that exist, so
       a brand with nothing in the catalogue yet returned an empty dropdown:
       that is the SHIFTR bug. Matrix entries carry their own apiName, which
       is the vocabulary the parts search matches on, so several Gen 3 models
       collapse onto one "Generation 3 Trailer" option rather than offering
       seven that all return the same parts. */
    var byVal = {};
    var order = [];
    var push = function (value, label) {
      var v = String(value == null ? "" : value).trim();
      if (!v) return;
      var k = v.toUpperCase();
      if (!(k in byVal)) {
        byVal[k] = { v: v, l: String(label || v) };
        order.push(k);
        return;
      }
      if (byVal[k].l !== String(label || v)) byVal[k].l = byVal[k].v;
    };
    pool.models.forEach(function (n) {
      if (!brandOk(n)) return;
      if (year && !coversYear(n, year)) return;
      push(n, n);
    });
    (M.matrix && M.matrix.models ? M.matrix.models : []).forEach(function (mm) {
      if ((mm.brand === "SHIFTR") !== shiftrBrand) return;
      if (mm.usMarket === false) return;
      if (year && modelYears(mm).indexOf(year) === -1) return;
      push(mm.apiName || mm.name, mm.name);
    });
    var models = order.map(function (k) { return byVal[k]; });
    /* Years come off the matrix, not off the model list, so a brand with no
       parts in the catalogue yet (SHIFTR today) still offers its own years
       rather than an empty dropdown. */
    var allowed = {};
    if (model) {
      var picked = M.modelByName(model);
      if (picked) modelYears(picked).forEach(function (y) { allowed[y] = 1; });
      else pool.years.forEach(function (y) { allowed[y] = 1; });
    } else {
      (M.matrix && M.matrix.models ? M.matrix.models : []).forEach(function (mm) {
        if ((mm.brand === "SHIFTR") !== shiftrBrand) return;
        if (mm.usMarket === false) return;
        modelYears(mm).forEach(function (y) { allowed[y] = 1; });
      });
    }
    var years = pool.years.filter(function (y) { return allowed[y]; })
      .sort(function (a, b) { return Number(b) - Number(a); })
      .map(function (y) { return { v: y, l: y }; });
    models.sort(function (a, b) { return a.l < b.l ? -1 : a.l > b.l ? 1 : 0; });

    var cleared = false;
    if (optValues(mSel).join("|") !== values(models).join("|")) cleared = fillSelect(mSel, models) || cleared;
    if (optValues(ySel).join("|") !== values(years).join("|")) cleared = fillSelect(ySel, years) || cleared;
    if (cleared) {
      mSel.dispatchEvent(new Event("change", { bubbles: true }));
      ySel.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }


  /* 8. The three tab panels are different heights and the dialog is centred
     on the viewport, so switching tab moved the whole modal up or down under
     the cursor. Measure all three once per width and hand them one shared
     min-height, so the dialog neither resizes nor moves when you switch. A
     hidden panel is measured in place: shown, taken out of flow, made
     invisible for the read, then put back, all inside one frame. */
  var PANELS = ["vinPanelVin", "vinPanelPart", "vinPanelFilters"];
  var panelW = 0;

  function panelSync() {
    var content = document.querySelector(".vin-modal .vin-modal-content.fx-find");
    var form = document.getElementById("vinSearchForm");
    if (!content || !form || getComputedStyle(form).display === "none") {
      panelW = 0;
      return;
    }
    var w = form.clientWidth;
    if (!w || w === panelW) return;

    var tallest = 0;
    PANELS.forEach(function (id) {
      var p = document.getElementById(id);
      if (!p) return;
      var hidden = p.hidden;
      var style = p.getAttribute("style");
      p.style.minHeight = "0px";
      if (hidden) {
        p.hidden = false;
        p.style.position = "absolute";
        p.style.visibility = "hidden";
        p.style.pointerEvents = "none";
        p.style.width = w + "px";
      }
      var h = p.offsetHeight;
      if (hidden) p.hidden = true;
      if (style === null) p.removeAttribute("style"); else p.setAttribute("style", style);
      if (h > tallest) tallest = h;
    });
    if (!tallest) return;
    panelW = w;
    form.style.setProperty("--fx-panel-h", tallest + "px");
  }

  /* 9. A fit chip is a claim about one trailer. When the search context has a
     year but no model the engine can only answer "likely" for almost every
     part, and a grid of thirty eight "Likely fits trailer" chips reads as a
     fault rather than as the honest "not enough known yet" it is. Hide the
     chips in that state. The note above the grid already says an exact answer
     needs the VIN. */
  function fitChips() {
    var host = document.querySelector("vin-search-modal");
    var t = host && host.trailerData;
    var name = t ? String(t.modelName || t.displayModelName || "").trim() : "";
    var known = !t || (!!name && !/^all models$/i.test(name));
    document.documentElement.classList.toggle("fx-nomodel", !known);
  }

  /* 10. The My trailer drawer's footer buttons, while the VIN modal is open.
     The drawer is a theme component (fx-recall.js) and both footer buttons
     close it and then scroll the PAGE to the hero VIN field or the identify
     strip. That is right on the home page and useless inside the VIN matched
     modal, where the hero sits behind an overlay: the drawer shut and nothing
     else happened. Inside the modal both intentions already have a home, so
     route them there. Capture phase, because fx-recall binds its own handler
     to the button itself and stopPropagation during capture never lets the
     event reach it. */
  function closeDrawer() {
    var drawer = document.querySelector(".fx-rc");
    if (drawer) drawer.classList.remove("is-open");
    document.documentElement.classList.remove("fx-recall-lock");
  }

  function drawerButtons() {
    document.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest ? e.target.closest(".fx-rc__btn, .fx-rc__lnk") : null;
      if (!btn) return;
      if (!document.body.classList.contains("vin-modal-open")) return;
      var host = document.querySelector("vin-search-modal");
      if (!host || typeof host.reset !== "function") return;
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
      /* reset() already shows the search form, clears the result view and puts
         the modal back on the VIN tab, which is exactly "search a different
         VIN". Browse all models wants the visual identifier instead. */
      host.reset();
      if (btn.classList.contains("fx-rc__lnk") && typeof host.setSearchMode === "function") {
        host.setSearchMode("identify");
        return;
      }
      var field = document.getElementById("vinInput");
      if (field) setTimeout(function () { field.focus(); field.select(); }, 60);
    }, true);
  }

  /* 11. Policy links and the extension's bring-them-back redirect.
     vin-search-restore.js runs on every page load and, while the stored modal
     state carries a pending host return, replaces any page that is not the
     cart or a product page with the host page. A policy page is neither, so
     clicking Shipping on a product page loaded the policy and was thrown
     straight back out of it, which reads as the page glitching. The flag is
     there to rescue a shopper who wandered off; one who deliberately clicked
     Shipping has not wandered off. Drop the two pending flags on that click
     and leave the other thirteen keys of stored state alone, so the modal
     still restores on the host page and the policy page is allowed to stay
     put. Both storages, because the extension reads whichever is newer, and
     localStorage is shared between tabs so this covers the link opening in a
     new one too. */
  var STATE_KEY = "vinSearchModalState";

  function releasePendingReturn() {
    [window.localStorage, window.sessionStorage].forEach(function (store) {
      try {
        var raw = store.getItem(STATE_KEY);
        if (!raw) return;
        var state = JSON.parse(raw);
        if (!state || (!state.pendingHostReturn && !state.pendingCartReturn)) return;
        state.pendingHostReturn = false;
        state.pendingCartReturn = false;
        store.setItem(STATE_KEY, JSON.stringify(state));
      } catch (err) {
        /* Private mode, quota, malformed JSON. The link still works; it just
           bounces the way it did before. */
      }
    });
  }

  function policyLinks() {
    document.addEventListener("click", function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/policies/"]') : null;
      if (a) releasePendingReturn();
    }, true);
  }

  function tick() {
    frame = 0;
    filtersTab();
    panelSync();
    fitChips();
  }
  function schedule() {
    if (frame) return;
    frame = setTimeout(function () { frame = 0; tick(); }, 40);
  }
  function start() {
    drawerButtons();
    policyLinks();
    tick();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "hidden", "class"] });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
